import { ListGroup } from "react-bootstrap";
import { mfaOptions } from "modules/mfaOptions";
import IMFAOption from "interfaces/IMFAOption";
import { InputHTMLAttributes, useEffect, useState } from "react";
import MFAOptionItem from "./MFAOptionItem/MFAOptionItem";

import "./MFAOptions.scss";

interface MFAOptionsProp extends InputHTMLAttributes<HTMLInputElement> {
  userHasPhoneConfigured : boolean,
  register: any
}
const MFAOptions = ({ userHasPhoneConfigured, register }: MFAOptionsProp) => {
  const [updatedMFAOptions, setUpdatedMFAOptions] = useState<IMFAOption[]>([]);

  const renderMFAOptions = () => (
    updatedMFAOptions.map((mfaOption : IMFAOption, idx:number) => (<MFAOptionItem mfaOption={mfaOption} register={register} key={`mfaOption_${idx}`} />
    )));

  useEffect(() => {
    const mfaOpts = mfaOptions();
    if (!userHasPhoneConfigured) {
      mfaOpts.forEach(option => {
        if (option.id.includes("SMS_MFA")) {
          option.disabled = true;
        }
      });
    }
    setUpdatedMFAOptions(mfaOpts);
  }, []);

  return (
    <ListGroup variant="flush" className="striped highlight d-flex align-items-center mfa-options">
      {updatedMFAOptions.length > 0 && renderMFAOptions()}
    </ListGroup>
  );
};

export default MFAOptions;
